/* eslint-disable no-unused-vars */
import React from 'react';
import FormInput from '../../../Components/Ui/FormInput';
import FormSelect from '../../../Components/FormFields/FormSelect';
import { getActiveClientBrandConfig } from '../../../config/environment.config';
import { useAiciOnboardingContexte } from '../../../Contexts/AiciOnboardingContexte';
import StepShell from '../StepShell';

/** Civilité → genre (sémantique URSSAF : '1' homme, '2' femme). */
const CIVILITES = [
    { label: 'Madame', gender: '2' },
    { label: 'Monsieur', gender: '1' },
];

const PersonalInfoStep = () => {
    const {
        personal, personalErrors, setPersonal, validatePersonal, saveAndGoTo, saving,
    } = useAiciOnboardingContexte();

    const civiliteIndex = CIVILITES.findIndex((c) => c.gender === personal.gender);

    const handleNext = () => {
        if (validatePersonal()) saveAndGoTo(2);
    };

    return (
        <StepShell
            title="Vérifiez vos informations"
            subtitle="Elles doivent être identiques à celles de votre déclaration fiscale pour être acceptées par l'URSSAF."
            onNext={handleNext}
            nextLoading={saving}
            requiredLegend
        >
            <div className="flex flex-col gap-4">
                <FormSelect
                    label="Civilité"
                    data={CIVILITES.map((c) => c.label)}
                    defaultValue={civiliteIndex >= 0 ? civiliteIndex + 1 : ''}
                    callback={(idx) => {
                        const gender = CIVILITES[idx - 1]?.gender ?? '';
                        // Le nom de naissance ne concerne que les femmes : on le réinitialise sinon.
                        setPersonal(gender === '2' ? { gender } : { gender, birthName: '' });
                    }}
                    error={personalErrors.gender}
                    required
                />

                <FormInput
                    label="Nom d'usage"
                    placeholder="Ex : Dupont"
                    value={personal.name}
                    onChange={(e) => setPersonal({ name: e.target.value.slice(0, 80) })}
                    error={personalErrors.name}
                    required
                    isEditing
                />

                {/* Nom de naissance demandé uniquement aux femmes (Madame). */}
                {personal.gender === '2' && (
                    <FormInput
                        label="Nom de naissance"
                        placeholder="Ex : Martin"
                        value={personal.birthName}
                        onChange={(e) => setPersonal({ birthName: e.target.value.slice(0, 80) })}
                        error={personalErrors.birthName}
                        required
                        isEditing
                    />
                )}

                <FormInput
                    label="Prénom(s)"
                    placeholder="Ex : Abdoulaye"
                    value={personal.firstName}
                    onChange={(e) => setPersonal({ firstName: e.target.value.slice(0, 80) })}
                    error={personalErrors.firstName}
                    required
                    isEditing
                />

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <FormInput
                        label="E-mail"
                        type="email"
                        placeholder="julie.dupont@gmail.com"
                        value={personal.mail}
                        onChange={(e) => setPersonal({ mail: e.target.value })}
                        error={personalErrors.mail}
                        autoComplete="email"
                        required
                        isEditing
                    />
                    <FormInput
                        label="Téléphone"
                        type="tel"
                        placeholder="0612345678"
                        value={personal.phoneNumber}
                        onChange={(e) => setPersonal({ phoneNumber: e.target.value })}
                        error={personalErrors.phoneNumber}
                        autoComplete="tel"
                        required
                        isEditing
                    />
                </div>

                <FormInput
                    label={`Prénom ${getActiveClientBrandConfig('', "de l'", 'du ')} (si différent)`}
                    placeholder="Ex : Juliette"
                    value={personal.studentName}
                    onChange={(e) => setPersonal({ studentName: e.target.value.slice(0, 80) })}
                    error={personalErrors.studentName}
                    isEditing
                />

                <p className="text-xs italic text-gray-500">
                    Vérifiez l'exactitude de votre adresse e-mail : vous en aurez besoin pour vous connecter à votre compte URSSAF.
                </p>
            </div>
        </StepShell>
    );
};

export default PersonalInfoStep;
